module.exports = __webpack_public_path__ + "img/614.Broken_chair.39dbf2ff.svg";